// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<{ isCSOrder: boolean }>;

export const DispatchSetIsCSOrder: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/CheckoutReviewAndSubmit/SetIsCSOrder",
        isCSOrder: props.parameter.isCSOrder,
    });
};

export const chain = [DispatchSetIsCSOrder];

const setIsCSOrder = createHandlerChainRunner(chain, "SetIsCSOrder");
export default setIsCSOrder;
